import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthGuard } from 'app/core/services/auth.guard';
import { FuseSharedModule } from '@fuse/shared.module';
import { mdwBewerkenComponent } from './mdwbewerken.component';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatFormFieldModule} from '@angular/material/form-field';
import { MatInputModule} from '@angular/material/input';
import { MatButtonModule} from '@angular/material/button';
import { MatDatepickerModule} from '@angular/material/datepicker';
import { MatSelectModule} from '@angular/material/select';
import { MultiSelectModule} from 'primeng/multiselect';
import { MatRadioModule } from '@angular/material/radio';
import { MatTabsModule, } from '@angular/material/tabs';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core'

const routes: any = [
    {
        path     : 'employees/edit',
        component: mdwBewerkenComponent,
        data: { roles: ['mws'] },
        canActivate: [AuthGuard]
        
    },
    {   
        path: 'employees/edit/:medewerkerid', 
        component: mdwBewerkenComponent,
        data: { roles: ['mws'] } ,
        canActivate: [AuthGuard] , 
    }
];

@NgModule({
    declarations: [
        mdwBewerkenComponent
    ],
    imports     : [
        RouterModule.forChild(routes),
        MatRadioModule,
        MatTableModule,
        MatTabsModule,
        MatSortModule,
        MatButtonModule,
        MatFormFieldModule,
        MatCheckboxModule,
        MatSelectModule,
        TranslateModule,
        MatInputModule,
        FuseSharedModule,
        MultiSelectModule,
        MatDatepickerModule,        
        MatNativeDateModule      ,   
    ],
    exports     : [
        mdwBewerkenComponent
    ]
})

export class mdwBewerkenModule
{
}
